import React from 'react';
import {Button, Grid, Modal, Typography} from "@material-ui/core";
import globalTheme from "../theme/globalTheme";
import {empty} from "../../state/utils/Common";

/**
 * 通知モーダル
 * @returns {{transform: string, top: string, left: string}}
 */
function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

/**
 * 通知モーダル
 * @param {boolean} isOpen - モーダル開閉状態
 * @param {boolean} isLoading - モーダルのロード中 フラグ
 * @param {string} loadingText - 読み込み状態のテキスト（送信ボタンを押したとき
 * @param {*} setClose - イベントでモーダルを閉じます。
 * @param {string} confirmationTitle - 確認用タイトル
 * @param {string} confirmationDescription - 確認事項
 * @param {string} deleteInformation - 情報（ユーザー名、アカウント名）などの削除
 * @param {string} buttonText - 送信ボタンのテキスト
 * @param {*} event - 確認イベント
 * @param {string} error - エラーメッセージ
 * @param {number} id - 関連ID UI
 */
export const AlertModal = (
    {
        isOpen,
        isLoading,
        loadingText,
        setClose,
        confirmationTitle,
        confirmationDescription,
        deleteInformation,
        buttonText,
        event,
        error,
    }) => {
    const [modalStyle] = React.useState(getModalStyle);
    // テーマのロード
    const classes = globalTheme._default();
    const defaultClass = globalTheme._default();
    return (
        <Modal open={isOpen}
               onClose={() => setClose({})}
               disableBackdropClick
               className={isLoading ? defaultClass.loading : undefined}
        >
            <div className={classes.modal} style={modalStyle}>
                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={12}>
                        <Typography
                            color="textPrimary"
                            variant="h3"
                            style={{'paddingTop': 0}}
                        >
                            {confirmationTitle}
                        </Typography>
                    </Grid>
                    {!empty(deleteInformation) &&
                    <Grid item xs={12}>
                        <Typography
                            color="textPrimary"
                            variant="body2"
                            style={{'paddingTop': 10}}
                        >
                            {deleteInformation}
                        </Typography>
                    </Grid>
                    }
                    {!empty(confirmationDescription) &&
                    <Grid item xs={12}>
                        <Typography
                            color="textPrimary"
                            variant="body2"
                            style={{'paddingTop': 5}}
                        >
                            {confirmationDescription}
                        </Typography>
                    </Grid>
                    }
                    {!empty(error) &&
                    <Grid item xs={12} style={{marginTop: 0}}>
                        <Typography variant={"body1"} className={defaultClass.error}>
                            {error}
                        </Typography>
                    </Grid>
                    }
                </Grid>
                <Grid item container justify="flex-end" spacing={2}>
                    <Grid item style={{marginTop: 16}}>
                        <Button
                            onClick={() =>
                                event()
                            }
                            variant="contained"
                            color={"primary"}
                            disabled={isLoading}
                            type="button"
                        >
                            {isLoading === true ? loadingText : buttonText}
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </Modal>
    );
}
